import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux'
import { ItemTypes } from './Constants';
import { DragSource, DropTarget } from 'react-dnd';
import AddonSettings from './AddonSettings';
import AddonContent from './AddonContent';
import { ModalManager} from '../helpers/index';
import SpPageBuilderModal from '../helpers/modal';
import { saveSetting } from '../actions/index';
import deepEqual from 'deep-equal'
import Style from 'style-it';
import _ from 'lodash'

import EditPanelManager from '../helpers/EditPanelManager';

const addonSource = {
  beginDrag(props){
    EditPanelManager.resetAll();
    return {
      id: props.id,
      index: props.index,
      rowIndex: props.rowIndex,
      colIndex: props.colIndex
    }
  }
}

const addonTarget = {
  hover( props, monitor, component ) {
    const item          = monitor.getItem();
    const dragIndex     = item.index;
    const hoverIndex    = props.index;

    if ( monitor.getItem().id === props.id) {
      return;
    }

    var element = findDOMNode(component),
    elementId = element.getAttribute('id');

    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
    const hoverMiddleY      = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    const clientOffset      = monitor.getClientOffset();
    const hoverClientY      = clientOffset.y - hoverBoundingRect.top;

    if(monitor.isOver({ shallow: true })){
      if (hoverClientY < hoverMiddleY) {
        element.classList.remove('bottom-placeholder');
        element.classList.add('top-placeholder');
      }
      if (hoverClientY > hoverMiddleY) {
        element.classList.add('bottom-placeholder');
        element.classList.remove('top-placeholder');
      }
    }

  },

  drop( props, monitor, component ) {
    const item          = monitor.getItem();
    const dragIndex     = item.index;
    const hoverIndex    = props.index;

    if ( monitor.getItem().id === props.id) {
      return;
    }

    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
    const hoverMiddleY      = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    const clientOffset      = monitor.getClientOffset();
    const hoverClientY      = clientOffset.y - hoverBoundingRect.top;

    var options = {
      drag        : item,
      dragIndex   : dragIndex,
      drop        : props,
      hoverIndex  : hoverIndex
    };

    if (hoverClientY < hoverMiddleY) {
      options.dropPosition = 'top';
    }

    if (hoverClientY > hoverMiddleY) {
      options.dropPosition = 'bottom';
    }

    if(item.type == 'ADD_ADDON'){

      return {
        type: 'addon',
        status: true,
        index: props.index,
        dropPosition: options.dropPosition,
        rowIndex: props.rowIndex,
        colIndex: props.colIndex
      };
    }

    if (typeof item.innerRowIndex === 'undefined') {
      if (item.rowIndex === props.rowIndex && item.colIndex === props.colIndex) {
        options.type = 'ADDON_SORT_COL_INNER';
      } else if (item.rowIndex === props.rowIndex && item.colIndex !== props.colIndex){
        options.type = 'ADDON_SORT_COL';
      } else {
        options.type = 'ADDON_SORT_OUTER_ROW';
      }
    } else {
      if (item.rowIndex === props.rowIndex && item.colIndex === props.colIndex) {
        options.type = 'ADDON_SORT_PARENT_COL_INNER';
      } else if (item.rowIndex === props.rowIndex && item.colIndex !== props.colIndex){
        options.type = 'ADDON_SORT_PARENT_COL';
      } else {
        options.type = 'ADDON_SORT_PARENT_OUTER_ROW';
      }
    }


    props.addonSort(options);

    monitor.getItem().index         = hoverIndex;
    monitor.getItem().innerRowId    = props.innerRowId;
    monitor.getItem().innerColId    = props.innerColId;
    monitor.getItem().rowIndex      = props.rowIndex;
    monitor.getItem().colIndex      = props.colIndex;
    monitor.getItem().innerRowIndex = props.innerRowIndex;
    monitor.getItem().innerColIndex = props.innerColIndex;
  }
};

class Addon extends Component {

  componentDidMount(){
    this.props.connectDragPreview( this.createCustomDragSource() );
  }

  componentDidUpdate(){
    this.props.connectDragPreview( this.createCustomDragSource() );
  }

  shouldComponentUpdate(nextProps, nextState){

    if(
      deepEqual(nextProps.addon, this.props.addon) &&
      deepEqual(nextProps.colIndex, this.props.colIndex) &&
      deepEqual(nextProps.column, this.props.column) &&
      deepEqual(nextProps.id, this.props.id) &&
      deepEqual(nextProps.index, this.props.index) &&
      deepEqual(nextProps.isDragging, this.props.isDragging) &&
      deepEqual(nextProps.isOver, this.props.isOver) &&
      deepEqual(nextProps.rowIndex, this.props.rowIndex) &&
      deepEqual(nextState, this.state)){
      return false;
    }

    return true;
  }

  createCustomDragSource(){
    var rowDragImg = pagebuilder_base + 'components/com_sppagebuilder/assets/images/addon.png';
    var img = new Image();
    img.src = rowDragImg;

    return img
  }

  editOnClickAddon(){
    const { addon, rowIndex, colIndex, column, index } = this.props;

    if( typeof addonsJSON[addon.name] == 'undefined' ){
      return;
    }

    let editAddon = {
      type: 'addon',
      index: rowIndex,
      settings: {
        colIndex: colIndex,
        addonIndex: index,
        addonId: addon.id,
        htmlContent: addon.htmlContent,
        assets: addon.assets,
        addonName: addon.name,
        formData: addon.settings
      }
    };

    EditPanelManager.setAddon(editAddon);
    EditPanelManager.setType('addon');

    EditPanelManager.showEditPanel();
  }

  render() {
    const { addon, rowIndex, colIndex, column, index, isOver, isDragging, connectDropTarget, connectDragPreview, connectDragSource } = this.props;

    var addonClass = "sp-pagebuilder-addon";
    var styles = {};
    if(isDragging && !isOver) {
      addonClass = "sp-pagebuilder-dragging " + addonClass;
      styles.display = 'none';
    }

    if ( isOver && !isDragging ) {
      addonClass = addonClass + ' sp-pagebuilder-addon-over';
    }

    if(!addon.visibility) {
      addonClass = addonClass + " sp-pagebuilder-addon-disabled";
    }

    let addonKey = 'addon-wrap-' + addon.id;


    return connectDragPreview(connectDropTarget(
      <div key={ addon.id } id={addonKey} className={addonClass}>
        <div className="addon-placeholder-top"><i className="fa fa-sort" /></div>
        <div className="sp-pagebuilder-addon-inner-wrap sp-pagebuilder-addon-inner-wrap-bordered">
          <div className="sp-pagebuilder-addon-tools">
            <AddonSettings
              addon = { addon }
              rowIndex = { rowIndex }
              colIndex = { colIndex }
              addonIndex = { index }
              column = { column }
              columnMove = { this.props.columnMove }
              connectDragSource = { connectDragSource }
              />
          </div>
          <AddonContent addon = { addon } editAddon={this.editOnClickAddon.bind(this)} />
        </div>
        <div className="addon-placeholder-bottom"><i className="fa fa-sort" /></div>
      </div>
    ))
  }
}

var DragSourceDecorator = DragSource( ItemTypes.ADDON, addonSource,
  function(connect, monitor) {
    return {
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging()
    };
  }
);

var DropTargetDecorator = DropTarget( [ ItemTypes.ADDON, ItemTypes.INNERROW, ItemTypes.INNERADDON ], addonTarget,
  function(connect,monitor) {

    return {
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver({ shallow: true }),
      canDrop: monitor.canDrop()
    };
  }
);

const mapStateToProps = ( state ) => {
  return {
    state: state
  };
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    onSettingsClick: (options) => {
      dispatch(saveSetting(options))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DropTargetDecorator(DragSourceDecorator(Addon)));



// WEBPACK FOOTER //
// ./src/components/Addon.js